import React, { useState } from 'react';

import AddAdminExperience from './AddAdminExperience';
import ViewExperience from './ViewExperience';

const AdminExperience = () => {
  const [activeTab, setActiveTab] = useState('add');

  return (
    <div className='admin-content'>
      <div className='admin-content__tabs '>
        <ul>
          <li
            onClick={() => setActiveTab('add')}
            className={activeTab === 'add' ? 'selected' : ''}
          >
            Add Experience
          </li>
          <li
            onClick={() => setActiveTab('view')}
            className={activeTab === 'view' ? 'selected' : ''}
          >
            View Experience
          </li>
        </ul>
      </div>

      <div className='admin-content__data'>
        {activeTab === 'add' && <AddAdminExperience />}
        {activeTab === 'view' && <ViewExperience />}
      </div>
    </div>
  );
};

export default AdminExperience;
